export default "__VITE_ASSET__CeuN9Nj3__"